import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import * as groups from "../_metronic/_partials/dashboards/_redux/groupsRedux";
import * as ticket from "../app/modules/Tickets/_redux/ticketRedux"
import * as lastCreatedTicket from "../app/modules/Play/_redux/PlayRedux";
import * as snackbar from "app/hoc/Snackbar/snackbarRedux";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  groups: groups.reducer,
  ticket: ticket.reducer,
  lastCreatedTicket: lastCreatedTicket.reducer,
  snackbar: snackbar.reducer
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
